import { t } from "@lingui/macro";
import { Container, Paper } from "@mui/material";
import AlertSnackbar from "../alertSnackbar";
import { ContainerWrapper } from "../containerWrapper";
import ContentHeaderToolbar from "../contentHeaderToolbar";
import FileCopy from "@mui/icons-material/FileCopy";
import AddIcon from "@mui/icons-material/Add";
import { AlertMessage } from "../../api/types";
import { useState } from "react";
import FilingImportDialog from "./filingImportDialog";

const Filings = () => {
  const [alertMessage, setAlertMessage] = useState<AlertMessage | undefined>(
    undefined
  );
  const [showImportFilingDialog, setShowImportFilingDialog] = useState(false);

  const handlecloseDialog = (
    updateStatus: "none" | "success" | "error",
    reason?: string
  ) => {
    setShowImportFilingDialog(false);
    if (updateStatus === "success" || updateStatus === "error") {
      setAlertMessage({
        message: reason || "",
        severity: updateStatus,
      });
    }
  };

  return (
    <>
      <ContainerWrapper>
        <Container
          maxWidth={false}
          sx={{
            ml: 0,
            mb: 10,
            overflow: "auto",
          }}
          component="div"
        >
          <Paper
            elevation={1}
            sx={{
              minHeight: 650,
              overflow: "auto",
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Container maxWidth={false}>
              <ContentHeaderToolbar
                titleIcon={<FileCopy fontSize="large" />}
                title={t`Filings`}
                actions={[
                  {
                    id: "addNew",
                    title: t`Create `,
                    icon: AddIcon,
                    disabled: false,
                    turnedOn: false,
                    clickAction: () => setShowImportFilingDialog(true),
                  },
                ]}
                CreateButton={true}
                createButtonWidth={220}
                showIcons={false}
              />
              <Container
                maxWidth={false}
                sx={{
                  backgroundColor: "transparent",
                  pr: "0!important",
                  pl: "0!important",
                }}
              >
                <iframe
                  title="ESEF-Filings 2025"
                  width="100%"
                  height="1000"
                  src="https://app.powerbi.com/reportEmbed?reportId=bdb6cb23-f78a-4d3b-9409-b18f463d00f4&autoAuth=true&ctid=1c752242-f6e5-4167-b354-2deda924b318"
                  frameBorder={0}
                  allowFullScreen={true}
                ></iframe>
              </Container>
            </Container>
          </Paper>
        </Container>

        <AlertSnackbar
          alertMessage={alertMessage}
          updateAlertStatus={setAlertMessage}
        />
      </ContainerWrapper>
      <FilingImportDialog
        open={showImportFilingDialog}
        onClose={handlecloseDialog}
      />
    </>
  );
};

export default Filings;
